/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button } from "@mui/material";

import React, { useEffect, useState } from "react";
import VehiclesMenu from "./VehiclesMenu";
import AuctionsMenu from "./AuctionsMenu";
import PortsMenu from "./PortsMenu";
import ClientsMenu from "./ClientsMenu";
import StatusMenu from "./StatusMenu";
import SearchOptionMenu from "./SearchOptionMenu";

import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import MultiFieldSearch from "./MultiFieldSearch ";
import { useSelector } from "react-redux";
import MixSearch from "./MixSearch";
import TreeMenu from "./TreeMenu";
import TransportCompanyMenu from "./TransportCompanyMenu";
import DestinationMenu from "./DestinationMenu";

const DropdownMenu = ({ onFetchData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const formReducer = useSelector((state) => state.form);
  const { accountType, loading } = useSelector((state) => state.user);

  const [adavancedSearchPrems, setAdavancedSearchPrems] = useState(
    formReducer?.data?.advancedSearches || []
  );

  useEffect(() => {
    if (formReducer.loading === "succeeded") {
      setAdavancedSearchPrems(formReducer?.data?.advancedSearches || []);
    }
  }, [formReducer.loading]);

  const handelResetFilter = () => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.delete("Clients");
    searchParams.delete("Auctions");
    searchParams.delete("Ports");
    searchParams.delete("SearchOption");
    searchParams.delete("Status");
    searchParams.delete("Vehicles");
    searchParams.delete("AdvancedSearch");
    searchParams.delete("TransportCompany");
    searchParams.delete("Destination");   
    searchParams.delete("MixSearch");
    searchParams.delete("BookingId");



    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={{
      p: { xs: 1, md: 2 },
      background: '#fff',
      borderRadius: 3,
      boxShadow: '0 2px 12px 0 rgba(11, 60, 93, 0.08)',
      mb: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
    }}>
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
      }}>
        <StatusMenu />
        {accountType !== "client" && !loading && <ClientsMenu />}
        <TreeMenu labelOpenButton="Vehicles" labelSelectAll="Select All" />
        <TransportCompanyMenu />
        <DestinationMenu />
        <PortsMenu />
        <SearchOptionMenu />
        {!adavancedSearchPrems ? null : <MultiFieldSearch filter={adavancedSearchPrems} />}
        <Button
          color="colorD"
          variant="outlined"
          sx={{ minWidth: 120, borderRadius: 2, fontWeight: 700, borderColor: '#D9B310', color: '#0B3C5D', '&:hover': { background: '#D9B31022', borderColor: '#D9B310', color: '#0B3C5D' } }}
          onClick={handelResetFilter}
        >
          {t("ResetFilter")}
        </Button>
        <Button
          variant="b1"
          sx={{ minWidth: 120, borderRadius: 2, fontWeight: 700 }}
          onClick={onFetchData}
        >
          {t('FetchData')}
        </Button>
      </Box>
      <Box sx={{ width: '100%' }}>
        <MixSearch />
      </Box>
    </Box>
  );
};

export default DropdownMenu;
